import React from "react";
import {
  SiteReadable as Site,
  SiteConfigurationInput,
} from "../../../services/client";
import { UploadSiteConfiguration } from "../../SiteDetails/SiteConfig/components/UploadSiteConfiguration/UploadSiteConfiguration";

type StepThreeProps = {
  setSite: (site: Site) => void;
  site?: Site;
};

export const StepThree: React.FC<StepThreeProps> = ({ setSite, site }) => {
  const addSiteConfigurationOnSite = (data: SiteConfigurationInput) => {
    if (!site || !site.site_id) {
      return;
    }

    setSite({
      ...site,
      configurations: {
        ...site.configurations,
        ucl_calculation_active:
          site.configurations?.ucl_calculation_active ?? false,
        forecasting_configuration: site.configurations
          ?.forecasting_configuration ?? { forecasted_devices: [] },
        // @ts-expect-error this fails because of a mismatch between derived properties and the uploaded site configuration
        // We are ignoring for now for speed of execution
        site_configuration: data,
      },
    });
  };

  return (
    <UploadSiteConfiguration
      onChange={(data) => addSiteConfigurationOnSite(data)}
      site_id={site?.site_id || "unknown"}
    />
  );
};

export default StepThree;
